import React from 'react';
import { Quest } from '../types';

interface QuestDetailsModalProps {
  quest: Quest;
  onClose: () => void;
  isSkillBuilderRepeat: boolean;
}

const QuestDetailsModal: React.FC<QuestDetailsModalProps> = ({ quest, onClose, isSkillBuilderRepeat }) => {
  const description = (isSkillBuilderRepeat && quest.repeatDescription) ? quest.repeatDescription : quest.description;
  const details = (isSkillBuilderRepeat && quest.repeatDetails) ? quest.repeatDetails : quest.details;

  return (
    <div 
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div 
        className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl p-6 w-full max-w-lg border border-slate-300 dark:border-slate-700 flex flex-col max-h-[90vh]"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-start">
            <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100">{quest.title}</h2>
            <button onClick={onClose} className="text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white text-3xl leading-none flex-shrink-0 ml-4">&times;</button>
        </div>
        
        <div className="mt-4 overflow-y-auto pr-2 space-y-6">
            <div>
                <h3 className="font-semibold text-lg text-slate-700 dark:text-slate-300 mb-1">Mission Briefing</h3>
                <p className="text-slate-600 dark:text-slate-400 whitespace-pre-wrap">{description}</p>
            </div>
            <div>
                <h3 className="font-semibold text-lg text-slate-700 dark:text-slate-300 mb-1">Extra Intel</h3>
                <p className="text-slate-600 dark:text-slate-400 whitespace-pre-wrap">{details}</p>
            </div>

            {quest.youtubeId && (
                <div>
                    <h3 className="font-semibold text-lg text-slate-700 dark:text-slate-300 mb-2">Video Guide</h3>
                    <div className="relative rounded-lg overflow-hidden" style={{ paddingBottom: '56.25%' /* 16:9 Aspect Ratio */ }}>
                        <iframe
                            className="absolute top-0 left-0 w-full h-full"
                            src={`https://www.youtube.com/embed/${quest.youtubeId}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded YouTube Guide"
                        ></iframe>
                    </div>
                </div>
            )}
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 text-white font-semibold rounded-lg transition-colors"
            style={{ backgroundColor: 'var(--primary-600)'}}
            onMouseOver={e => e.currentTarget.style.backgroundColor = 'var(--primary-700)'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = 'var(--primary-600)'}
          >
            Got It
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestDetailsModal;